import axios from "axios";
import { env } from "@/config";
import type { AssistedAffiliationValidationResponse } from "@/screens/AssistedAffiliationRnc/types";
import type { AssistedAffiliationValidationInput } from "./types";

export const postValidations = <T = AssistedAffiliationValidationResponse>(
  validations: AssistedAffiliationValidationInput[],
  signal?: AbortSignal
) =>
  axios.post<T>(
    `${env.ASSISTED_AFFILIATION_API_URL}/v1/assisted-affiliation/validate`,
    { validations },
    {
      headers: { "Content-Type": "application/json" },
      ...(signal ? { signal } : {}),
    }
  );
